export const Colors = {
    primaryColor: "#2EAAFA",
    secondaryColor: "#1F2F98"
}